require('../../modules/es6.array.is-array');
module.exports = require('../../modules/_core').Array.isArray;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/fn/array/is-array.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/fn/array/is-array.js
// module chunks = 6